import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
  },
  buttonInner: {},
  buttonHover: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDisable,
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 20,
    textAlign: 'center',
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightTextDefault,
  },
  textHover: { color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightTextDefault },
  textPressed: { color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightTextDefault },
  textFocus: { color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightTextDefault },
  textDisabled: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightTextDisable,
  },
  icon: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconHover: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconPressed: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
  iconDisabled: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDisable,
  },
  iconFocus: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
  },
});
